import { render, staticRenderFns } from "./SlcViewOptionMenu.vue?vue&type=template&id=634fef13&"
import script from "./SlcViewOptionMenu.vue?vue&type=script&lang=ts&"
export * from "./SlcViewOptionMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlcViewOptionMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports